// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"NewLeadModal-module-e9a2d8b8c0c320617416"};